module.exports = __webpack_public_path__ + "static/media/iconphone.260807e1.svg";